var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultipleSelect',{attrs:{"data-private":"","hideDetails":"","itemValue":"id","label":_vm.$t('common.tag_other'),"options":_vm.tagsOptions,"value":_vm.value,"search-input":_vm.searchTerm},on:{"update:searchInput":function($event){_vm.searchTerm=$event},"update:search-input":function($event){_vm.searchTerm=$event},"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }